import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NzContentComponent, NzLayoutComponent } from 'ng-zorro-antd/layout';

@Component({
  selector: 'aad-fullscreen-layout',
  templateUrl: 'fullscreen-layout.component.html',
  styleUrl: 'fullscreen-layout.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, NzLayoutComponent, NzContentComponent],
})
export class FullscreenLayoutComponent {}
